import { render } from "./SidebarLayout.vue?vue&type=template&id=1e495338"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
script.render = render

export default script